// extracted by mini-css-extract-plugin
export var subItem = "LinkList-module--subItem--kS5ED";
export var listItems = "LinkList-module--listItems--1TlgJ";
export var item = "LinkList-module--item--3oz0A";
export var subItemTitle = "LinkList-module--subItemTitle--272aM";
export var subItemUrl = "LinkList-module--subItemUrl--1neX4";